<template>
  <div>
    <div class="row mb-2 mt-0" v-if="(repsHistory.length > 0 || menteeSkillPassContent != '')">
      <div class="col-6 pl-4">
        <div class="text-uppercase font-weight-bold">Rep History</div>
      </div>
      <div class="col-6 pr-4 text-right"></div>
    </div>

    <div class="row mb-2 mt-0" v-if="menteeSkillPassContent">
      <div class="col-12 pl-4">
        <div class=""><b>Note: </b> {{ menteeSkillPassContent }} </div>
      </div>
      <div class="col-6 pr-4 text-right"></div>
    </div>


    <MenteeRepHistoryReview 
      v-for="(rep, index) in repsHistory"
      :key="rep.id"
      :repTask="formatRepTask(rep)" 
      :menteeFirstName="menteeFirstName"
      :menteeShortName="menteeShortName"
      :menteeId = "menteeId"
      alignApproveDenyBtns="type4"
      action="rep_history_review"
      @closeMenteeEditRepModal="closeMenteeEditRepModal"
      clockIconPositionClass="clock-icon-position-middle"
    ></MenteeRepHistoryReview>

  </div>
</template>

<script>
import axios from 'axios';
import MenteeRepHistoryReview from '@/components/manager/mentee_rep_review.vue';

export default {
  props: [],
  data() {
    return {
      repsHistory: [],
      menteeId: '',
      menteeFirstName: '',
      menteeShortName: '',
      taskListId: '',
      subTaskId: '',
      taskId: '',
      isSection: '',
      tasklistName: '',
      taskName: '',
      subTasks: [],
      menteeSkillPassContent: '',
    }
  },
  computed: {
    
  },
  methods: {
    formatRepTask(rep) {
      let repTask = {
        taskListId: this.taskListId,
        subtask_id: this.subTaskId,
        taskListName: this.tasklistName,
        taskName: this.taskName,
        createdAt: rep.createdAt,
        minutes: rep.timeOnTask,
        score: rep.score,
        repId: rep.id,
        comment: rep.comment,
        menteeComment: rep.menteeComment,
      };

      if (this.isSection == 'yes') {
        repTask.subtaskTasks = this.subTasks;
      } else {
        repTask.taskId = this.taskId;
      }

      return repTask;
    },
    closeMenteeEditRepModal() {
      this.$emit('closeMenteeEditRepModal');
    },
    getRepHistory(taskListId, subTaskId, taskId, menteeId, isSection, menteeFirstName, menteeShortName, tasklistName, taskName, subTasks) {
      this.menteeId = menteeId;
      this.menteeFirstName = menteeFirstName;
      this.menteeShortName = menteeShortName;
      this.taskListId = taskListId;
      this.subTaskId = subTaskId;
      this.taskId = taskId;
      this.isSection = isSection;
      this.tasklistName = tasklistName;
      this.taskName = taskName;
      this.subTasks = subTasks;
      axios('/mobile/mentee-repetitions-task', {
        method: 'GET',
        params: {
          account_id: this.$store.state.user_accountid, 
          mentee_id: this.menteeId,
          tasklist_id: this.taskListId,
          task_id: this.taskId ? this.taskId : this.subTaskId,        
          is_section: this.isSection == 'yes' ? true : false,
        }
      })
      .then(resp => {
        let data = resp.data;
        this.repsHistory = data.repetition;
        this.menteeSkillPassContent = data.menteeSkillPassContent;
      })
      .catch(() => {});

      },
  },
  components: {
    MenteeRepHistoryReview,
  },
  created() {

  },
  mounted() {
    
  }
}
</script>


// WEBPACK FOOTER //
// src/components/manager/mentee_rep_history.vue